import { render } from "./ImagesModal.vue?vue&type=template&id=148bf81e&scoped=true"
import script from "./ImagesModal.vue?vue&type=script&lang=js"
export * from "./ImagesModal.vue?vue&type=script&lang=js"

import "./ImagesModal.vue?vue&type=style&index=0&id=148bf81e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-148bf81e"

export default script